import { Button } from "frontend-components";
import type { ButtonHTMLAttributes } from "react";

export default function ActionButton({
    label,
    primary = false,
    children,
    ...props
}: {
    label: string;
    primary?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <Button
            type="button"
            variant={primary ? "fill" : "outline"}
            className={primary ? "gap-2" : "gap-2 bg-compendia-card"}
            {...props}
        >
            {children}
            {label}
        </Button>
    );
}
